module.exports = __webpack_public_path__ + "static/media/im2.a297a467.png";